(function () {
  var sourceFilename = 'ripple_fold_sheer550.webp';
  var replacementUrl =
    'https://cdn.shopify.com/s/files/1/0862/2506/0158/files/ripple-fold-sheer-effortless-elegance-v2.png?v=1790384680';

  function replaceDescriptionImages() {
    var images = document.querySelectorAll(
      '.tc-box .tc-image img[src*="' + sourceFilename + '"]'
    );

    images.forEach(function (image) {
      image.removeAttribute('srcset');
      image.src = replacementUrl;
      image.alt = 'Ivory ripple fold sheer curtains in a refined neutral room';
    });
  }

  replaceDescriptionImages();

  var observer = new MutationObserver(function () {
    replaceDescriptionImages();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
